export const Roles = [{
  id: 0,
  name: "Student"
}, {
  id: 1,
  name: "Administrator"
}];